module.exports = __webpack_public_path__ + "img/V-Ray.001e2e83.png";